import { teamEmailAddressSchema } from "@redotech/redo-marketing-core-common/email/domain-verification";
import * as z from "zod";

export const sendVerificationEmail = {
  name: "sendVerificationEmail" as const,
  input: z.object({ address: teamEmailAddressSchema }),
  output: z.null(),
};
